<template>
  <v-list class="pl-list" three-line>
    <filter-list-item
      v-for="filter in currentFilters"
      :filter="filter"
      :key="filter['.key']"/>
  </v-list>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FilterListItem from './FilterListItem'

export default {
  name: 'FilterList',

  components: {
    FilterListItem
  },

  computed: mapGetters('filters', ['currentFilters']),

  methods: mapActions('filters', ['getCurrentFilters']),

  mounted () {
    this.getCurrentFilters(this.$route.params.subcategoryId)
  }
}
</script>
